import { Component, EventEmitter, Input, Output } from "@angular/core";
import { BookmarkUrl } from "src/app/constants/url/bookmark.url";
import { ResponseDto } from "src/app/dto/common/response.dto";
import { PointDto } from "src/app/dto/location/point.dto";
import { HttpService } from "src/app/service/http/http.service";

@Component({
    selector: 'bookmarkManager',
    templateUrl: '../../view/bookmark/manager.html'
})
export class BookmarkManagerComponent {
    @Input() public pointDto!: PointDto;
    @Output() public closeEvent: EventEmitter<any> = new EventEmitter<any>();

    constructor(private httpService: HttpService) {}

    public add(): void {
        if (this.pointDto.isValidBookmark()) {
            this.httpService.post<ResponseDto<void>>(BookmarkUrl.add, this.pointDto.toBookmarkDto())
                .subscribe(response => {
                    if (response.isSuccess) {
                        this.close();
                    }
                });
        }
    }

    public close(): void {
        this.closeEvent.emit();
    }
}
